module.exports = {
  NODE_ENV: 'development',
  API_ENDPOINT: 'http://localhost:9040/api/v2',
}
